define('views/modules/calendar/animated-session/exercise/weight/history/weight-history-header',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // parent
    'views/modules/calendar/animated-session/exercise/weight/weight-header',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/weight/history/weight-history-header.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // parent
    VWeightExerciseHeader,
    // templates
    TWeightHistoryHeader
) {

    var VWeightHistoryHeader = VWeightExerciseHeader.extend({
        template: TWeightHistoryHeader,
    });

    return VWeightHistoryHeader;

});

